import { api } from "@/api/client";
import { convertToURLSearchParams } from "@/util";
import { PaginatedSearch } from "@/types";
import { QualifierUser } from "../user";
import { RecordStandardGroup } from "../record";

export type StandardTest = {
  recordId: string;
  templateNumber: string;
};

export type TestListView = {
  id: string;
  number: string;
  standard: RecordStandardGroup;
  pinned: boolean;
};

export interface TestFilters extends PaginatedSearch {
  favorite: boolean;
  contractorId: string;
  searchString: string;
}

export type TestRequest = {
  projectNumber?: string;
  projectName?: string;
  projectDescription?: string;
  contractor?: string;
  wps?: string;
  processes?: string;
  materials?: string;
  thickness?: string;
  diameter?: string;
  position?: string;
  progression?: string;
  weldType?: string;
  weldingSpecialist?: QualifierUser;
  phoneNumber?: string;
  otherNeeds?: string;
};

export function getStandardTestList(filters: Partial<TestFilters>) {
  const params = convertToURLSearchParams(filters);
  return api.getPaginated<TestListView[]>(`williams/tests?${params}`);
}

export function getStandardTestLookup(search: string, contractorId?: string) {
  return api.get<StandardTest[]>(`williams/tests/lookup?contractorId=${contractorId}&search=${search}`);
}

export function getStandardTestById(id: string) {
  return api.get<StandardTest>(`williams/tests/${id}`);
}

export function submitRequest(request: TestRequest) {
  return api.post("williams/tests/request", request);
}

export function togglePinned(id: string) {
  return api.post(`williams/tests/pin?id=${id}`);
}
